











import Vue, { PropType } from 'vue'
import CheckBoxesAgrupados from 'src/typescript/common/CheckBoxes/CheckBoxesAgrupados'
import { formatarOpcoesCheckBoxesAgrupados } from 'src/typescript/common/CheckBoxes/utils'

import {
  TipoDeNotificacao,
  ICheckBoxesAgrupados
} from 'src/tipos'

interface Data {
  opcoesFormatadas: ICheckBoxesAgrupados;
}

interface Methods {
  formatarOpcoes: (tiposDeNotificacao: TipoDeNotificacao[]) => ICheckBoxesAgrupados;
}

interface Computed {
  valueInterno: TipoDeNotificacao[];
}

interface Props {
  value: TipoDeNotificacao[];
  desativado: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'NotificacaoVia',

  components: {CheckBoxesAgrupados},

  props: {
    value: {
      type: Array as PropType<TipoDeNotificacao[]>,
      required: true
    },
    desativado: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    valueInterno: {
      get (): TipoDeNotificacao[] {
        console.log(this.value)
        return this.value
      },
      set (valueInternoAtualizado: TipoDeNotificacao[]): void {
        this.$emit('input', valueInternoAtualizado)
      }
    }
  },

  data () {
    return {
      opcoesFormatadas: {} as ICheckBoxesAgrupados
    }
  },

  mounted (): void {
    this.opcoesFormatadas = this.formatarOpcoes(this.valueInterno)
  },

  methods: {
    formatarOpcoes (tiposDeNotificacao: TipoDeNotificacao[]): ICheckBoxesAgrupados {
      const opcoesIniciais = {
        'desktop': {
          valor: false,
          legenda: 'Navegador',
          icone: 'icon-linha-grande-navegador'
        },
        // 'email': {
        //   valor: false,
        //   legenda: 'E-mail',
        //   icone: 'icon-linha-grande-email'
        // },
        'mobile': {
          valor: false,
          legenda: 'Notificação push (via celular)',
          icone: 'icon-linha-grande-notificacao'
        }
      } as ICheckBoxesAgrupados
      return formatarOpcoesCheckBoxesAgrupados(tiposDeNotificacao, opcoesIniciais)
    }
  }
})
